import { IStatus } from '@dfl/mui-react-common';
import { t } from 'i18next';
import { OFFER_STATUS } from 'modules/sales-offer/common/constants/offer.enum';
import { BLUE, GREEN, RED, WARNING } from 'settings/theme';

export const OFFER_TYPES = [
  {
    value: 'FIXED',
    label: 'productDiscount:discountTypes.FIXED',
  },
  {
    value: 'PERCENT',
    label: 'productDiscount:discountTypes.PERCENT',
  },
];

export const PRODUCT_DISCOUNT_ENABLED: IStatus[] = [
  { _id: 'true', title: t('productDiscount:enabledTypes.ACTIVE'), color: GREEN },
  { _id: 'false', title: t('productDiscount:enabledTypes.INACTIVE'), color: RED },
];

export const PRODUCT_DISCOUNT_ENABLED_MAP = new Map<boolean, IStatus>([
  [true, PRODUCT_DISCOUNT_ENABLED[0]],
  [false, PRODUCT_DISCOUNT_ENABLED[1]],
]);

export const PRODUCT_DISCOUNT_STATUS: IStatus[] = [
  { _id: OFFER_STATUS.ACTIVE, title: `productDiscount:status.${OFFER_STATUS.ACTIVE}`, color: GREEN },
  { _id: OFFER_STATUS.SCHEDULED, title: `productDiscount:status.${OFFER_STATUS.SCHEDULED}`, color: WARNING },
  { _id: OFFER_STATUS.FINISHED, title: `productDiscount:status.${OFFER_STATUS.FINISHED}`, color: BLUE },
  { _id: OFFER_STATUS.DISABLED, title: `productDiscount:status.${OFFER_STATUS.DISABLED}`, color: RED },
];
export const PRODUCT_DISCOUNT_DISABLED_STATUS: IStatus[] = [
  { _id: OFFER_STATUS.ACTIVE, title: `productDiscount:status.${OFFER_STATUS.ACTIVE}`, color: GREEN },
];

export const PRODUCT_DISCOUNT_STATUS_MAP = new Map<OFFER_STATUS, IStatus>([
  [OFFER_STATUS.ACTIVE, PRODUCT_DISCOUNT_STATUS[0]],
  [OFFER_STATUS.SCHEDULED, PRODUCT_DISCOUNT_STATUS[1]],
  [OFFER_STATUS.FINISHED, PRODUCT_DISCOUNT_STATUS[2]],
  [OFFER_STATUS.DISABLED, PRODUCT_DISCOUNT_STATUS[3]],
]);
